import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './UserMenu.module.scss';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
import { NavLink } from 'react-router-dom';

function UserMenu(props) {
  const ref = useRef();
  const [open, setOpen] = useState(false);

  useOnClickOutside(
    ref,
    useCallback(() => setOpen(false), []),
  );

  const handleClick = (e) => {
    if (ref.current === e.target) {
      setOpen(!open);
    }
  };

  return (
    <span onClick={handleClick} className="ic-account" ref={ref}>
      <div className={cn(styles.userMenu, open ? styles.open : '', props.suppliersMenu ? styles.suppliers : '')}>
        <div className={styles.inner}>
          <section>
            <div className={styles.menuItem}>{props.username}</div>
            <div className={styles.menuItem}>{props.email}</div>
          </section>

          <hr />

          <section>
            <div>
              <NavLink
                to="/user/account"
                className={cn(styles.menuItem, styles.menuItemLink)}
                activeClassName={styles.currentMenuItem}
              >
                Settings
              </NavLink>
            </div>
          </section>

          <hr />

          <section>
            <div className={cn(styles.menuItem, styles.menuItemLink)} onClick={props.logout}>
              <span>Log out</span>
            </div>
          </section>
        </div>
      </div>
    </span>
  );
}

export default UserMenu;

UserMenu.defaultProps = {
  suppliersMenu: false,
};

UserMenu.propTypes = {
  logout: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  suppliersMenu: PropTypes.bool.isRequired,
};
